// What a browser remembers for one person: where they were last, nothing more. Storage may be missing (a private
// window) and the app works the same without it. Never a value from the vault.
export function remembered(key: string): string | null {
    try {
        return localStorage.getItem(`fs.${key}`);
    } catch {
        return null;
    }
}

export function remember(key: string, value: string): void {
    try {
        localStorage.setItem(`fs.${key}`, value);
    } catch {
        // Not remembered: fine.
    }
}
